import { TContainerLengths } from "open-vessel-definition";
import { feetToMillimeters } from "@tedivo/tedivo-pure-helpers";

export const SVG_WIDTH = 1500;

export const LCG_SEPARATION = feetToMillimeters(13);
export const LCG_20 = feetToMillimeters(24);
export const SEPARATION_IN_BETWEEN = feetToMillimeters(3);
export const LCG_20_WITH_SEPARATION = LCG_20 + SEPARATION_IN_BETWEEN;
export const TCG_IN_MMM = 2520;
export const VCG_SEPARATION_TO_DECK = feetToMillimeters(3);

export const CONTAINER_WIDTH_IN_FEET = 8;
export const CONTAINER_WIDTH_IN_MMM = feetToMillimeters(CONTAINER_WIDTH_IN_FEET);
export const CONTAINER_HEIGHT_IN_FEET = 8.5;
export const CONTAINER_SEPARATION_IN_FEET = 0.5;
export const CONTAINER_HEIGHT_IN_MMM = feetToMillimeters(CONTAINER_HEIGHT_IN_FEET);
export const CONTAINER_SEPARATION_IN_MMM = feetToMillimeters(CONTAINER_SEPARATION_IN_FEET);

/** @deprecated We use millimeters */ export const ONE_METER_IN_FEET = 3.280839895;

export const ONE_MILLIMETER_IN_FEET = 0.003280839895;
export const CONT_LENS: TContainerLengths[] = [20, 24, 40, 45, 48, 53];

export const FEET_20_IN_MM = feetToMillimeters(20);
export const FEET_10_IN_MM = feetToMillimeters(10);

/**
 * Lashing bridge drawing assumptions (OVD doesn't define them).
 * Fore-aft depth of the structure (FWD to AFT), in mm.
 */
export const LASHING_BRIDGE_THICKNESS_IN_MM = 1300;

/**
 * Clear fore-aft depth of the top walkway between its handrails, in mm. Outside, the top section
 * is as deep as the structure: the handrails and stanchions are thick bars filling the rest
 */
export const LASHING_BRIDGE_TOP_WALKWAY_DEPTH_IN_MM = 750;

/**
 * Height of the handrail over the top walkway, in tiers. The top walkway is at the bridge's
 * `tiers`/`height`, so a 3-tier bridge tops out at 3.5 tiers.
 */
export const LASHING_BRIDGE_RAIL_HEIGHT_TIERS = 0.5;

/**
 * Narrowest gap between two blocks of bays (with no vessel part in between) that fits two
 * lashing bridges, in mm. Below it, the AFT bridge of the bow block and the FWD bridge of the
 * stern block would be the same one, so only the FWD one is offered.
 */
export const LASHING_BRIDGE_MIN_DOUBLE_GAP_IN_MM = 2600;

/** Narrowest gap between two bays that counts as a lashing bridge gap, in mm */
export const LASHING_BRIDGE_MIN_GAP_IN_MM = 500;

/**
 * Clearance between the end of the bay and a lashing bridge standing off it, in mm, when the
 * vessel has no gaps between bays to take the typical one from
 */
export const LASHING_BRIDGE_END_CLEARANCE_IN_MM = 500;

/**
 * Clearance between a lashing bridge and a vessel part (deckhouse, smokestack, crane...) drawn
 * next to it, in mm. See `getVesselPartClearSpan`
 */
export const LASHING_BRIDGE_PART_CLEARANCE_IN_MM = 250;
